"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.waitCanceleable = void 0;
var common_1 = require("./common");
var waitCanceleable = function (ms) {
    var startTime = Date.now();
    var enabled = true;
    var duration = ms;
    var resolve;
    var timeout;
    var resolveWith = function (state) {
        enabled = false;
        clearTimeout(timeout);
        var endTime = startTime + duration;
        var delta = common_1.getTimeDiffFromNow(endTime);
        resolve({
            state: state,
            startTime: startTime,
            duration: duration,
            endTime: endTime,
            delta: delta
        });
    };
    var setTime = function (newMs) {
        if (!enabled) {
            return;
        }
        clearTimeout(timeout);
        duration = newMs;
        var diff = common_1.getTimeDiffFromNow(startTime);
        timeout = setTimeout(function () { return resolveWith('completed'); }, duration - diff);
    };
    var getDuration = function () { return duration; };
    var promise = new Promise(function (r) {
        resolve = r;
        setTime(ms);
    })
        .finally(function () {
        clearTimeout(timeout);
    });
    var cancel = function () {
        if (!enabled) {
            return;
        }
        clearTimeout(timeout);
        resolveWith('canceled');
    };
    return { promise: promise, cancel: cancel, setTime: setTime, getDuration: getDuration };
};
exports.waitCanceleable = waitCanceleable;
